<template>
  <div>
    <page-header>
      <h2>Карточка новости</h2>
      <template #actions>
        <button-component @click='goBack()'>К списку новостей</button-component>
      </template>
    </page-header>

    <section class="content">      
      <div v-if="item && newsImages.length" class="image_container">
        <carousel
          :items-to-show="1"
          :wrapAround="true"
          :transition="500"
          v-if="newsImages?.length > 1"
        >
          <slide v-for="(item,index) in newsImages" :key="index">
            <img class="news-image" :src="getFileUrl(item.guid)" alt="">              
          </slide>

          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </carousel>

        <template v-else-if="newsImages?.length == 1">
          <img class="news-image" :src="getFileUrl(item.guid)" alt="" v-for="(item, index) in newsImages" :key="index">
        </template>
      </div>

      <div class="item-col">
          <p class="news-title">{{ item.name }}</p>
          <p class="news-date">{{ $momentFormat(item.activeFrom, "DD MMMM YYYY") }}</p>
          <p v-html="item.body"></p>
          <div class="block-title" v-if="newsFiles?.length">
            <div class="block-etc">
              <div class="list-container">
                <strong>Дополнительные материалы:</strong>
                <ul class="list-documents">
                  <li v-for="item in newsFiles" :key="item.key">
                    <a class="news-file-link" href="javascript:" @click="downloadFile(item)"><i class="fa fa-file"></i> {{item.fileName ?? item.originalName}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </section>
  </div>  
</template>
<script>
import PageHeader from "@/common/components/page/PageHeader";
import ButtonComponent from "@/common/ui/ButtonComponent";
import API from '@/modules/settings/api/news';
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import Utils from "@/common/utils";
import runtimeConfig from '@/common/runtime-config';

export default {
  name: "NewsPublicCard",
  components: {
    PageHeader, ButtonComponent, Carousel, Slide, Navigation, Pagination
  },
  created() {
    this.loadPage();
  },
  data() {
    return {
      id: this.$route.params.id,
      item: {
        files: []
      },
      fileType: {
        photo: 1,
        other: 2
      },      
    };
  },
  methods: {
    loadPage() {
      if (this.id >0)
        API.find(this.id).then((response) => {
          this.item = response.data;        
        });
    },
    goBack() {
      this.$router.push({ name: "Help" });
    },
    getFileUrl(id) {
      if (id) {
        console.log(id);
        const baseUrl = runtimeConfig.apiBaseUrl;
        return `${baseUrl}/api/file/downloadByGuid?guid=${id}`;
      }
    },
    downloadFile(file) {
      return Utils.downloadFile(`/api/file/download?id=${file.id}`, file.originalName);
    },
  },
  computed: {
    newsImages() {
      return this.item?.files?.filter(x => x.newsFileType == this.fileType.photo);
    },
    newsFiles() {
      return this.item?.files?.filter(x => x.newsFileType == this.fileType.other);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 32px;
  position: relative;
  overflow-y: visible;
}

.image_container {
  padding: 8px;
  float: left;
  max-width: 50%;
  width: 50%;
  height: 400px;
  max-height: 400px;  
}

.image_container::v-deep {
  .carousel,
  .carousel__viewport,
  .carousel__track,
  .news-image {
    width: 100%;
    height: 100%;
  }
  .carousel__pagination {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-left: 0;
  }
  .news-image {
    object-fit: contain;
  }
}

.news-title {
  font-weight: 700;
  font-size: 1.2rem;
  margin-bottom: 0;
}

.news-date {
  font-weight: 300;
  font-size: 12px;
  line-height: 200%;
  color: #969595;
}
.list-documents {
  padding-left: 0;
}

.news-file-link {
  text-decoration: none;
  color: #444;
}

.news-file-link:hover {
  text-decoration: underline dotted;  
  color: #000;
}
</style>